export const SUPPORT_WHATSAPP_DISPLAY_NUMBER = '073-2190522';
export const SUPPORT_WHATSAPP_NUMBER = '+972732190522';
export const SUPPORT_EMAIL = 'agents@madlan.co.il';
export const SUPPORT_WHATSAPP_NUMBER_MANAGE_BULLETINS = '+972778041418';
export const SUPPORT_EMAIL_MANAGE_BULLETINS = 'desk@madlan.co.il';
